(() => {
	function initProductGalleries(root = document) {
		if (typeof window.Swiper !== 'function') return;

		const galleries = root.querySelectorAll('[data-product-gallery-swiper]');
		galleries.forEach((gallery) => {
			if (gallery.dataset.galleryInitialized === 'true') return;
			gallery.dataset.galleryInitialized = 'true';

			const mainEl = gallery.querySelector('[data-gallery-main]');
			if (!mainEl) return;

			const thumbsEl = gallery.querySelector('[data-gallery-thumbs]');

			let thumbsSwiper = null;
			if (thumbsEl) {
				thumbsSwiper = new window.Swiper(thumbsEl, {
					freeMode: true,
					watchSlidesProgress: true,
					slidesPerView: 5,
					spaceBetween: 8,
				});
			}

			new window.Swiper(mainEl, {
				loop: true,
				navigation: {
					nextEl: gallery.querySelector('.swiper-button-next'),
					prevEl: gallery.querySelector('.swiper-button-prev'),
				},
				thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
			});
		});
	}

	document.addEventListener('DOMContentLoaded', () => initProductGalleries());

	document.addEventListener('shopify:section:load', (event) => {
		const sectionRoot = event?.target;
		if (sectionRoot instanceof HTMLElement) initProductGalleries(sectionRoot);
	});
})();
